(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea8e2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea8e2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("cw5Bf", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $91ccd1319f241544$export$6503ec6e8aabbaf; }, function (v) { return $91ccd1319f241544$export$6503ec6e8aabbaf = v; });
var $91ccd1319f241544$export$6503ec6e8aabbaf;
var $91ccd1319f241544$export$f7ad0328861e2f03;
"use strict";
var $91ccd1319f241544$var$mapping = new Map();
function $91ccd1319f241544$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$91ccd1319f241544$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $91ccd1319f241544$var$resolve(id) {
    var resolved = $91ccd1319f241544$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$91ccd1319f241544$export$6503ec6e8aabbaf = $91ccd1319f241544$var$register;
$91ccd1319f241544$export$f7ad0328861e2f03 = $91ccd1319f241544$var$resolve;

});

parcelRegister("cPIEy", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $957ce2a762fdd5ca$export$bdfd709ae4826697; }, function (v) { return $957ce2a762fdd5ca$export$bdfd709ae4826697 = v; });
var $957ce2a762fdd5ca$export$bdfd709ae4826697;
var $957ce2a762fdd5ca$export$c9e73fbda7da57b6;
var $957ce2a762fdd5ca$export$5a759dc7a1cfb72a;
"use strict";
var $957ce2a762fdd5ca$var$bundleURL = {};
function $957ce2a762fdd5ca$var$getBundleURLCached(id) {
    var value = $957ce2a762fdd5ca$var$bundleURL[id];
    if (!value) {
        value = $957ce2a762fdd5ca$var$getBundleURL();
        $957ce2a762fdd5ca$var$bundleURL[id] = value;
    }
    return value;
}
function $957ce2a762fdd5ca$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $957ce2a762fdd5ca$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $957ce2a762fdd5ca$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $957ce2a762fdd5ca$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$957ce2a762fdd5ca$export$bdfd709ae4826697 = $957ce2a762fdd5ca$var$getBundleURLCached;
$957ce2a762fdd5ca$export$c9e73fbda7da57b6 = $957ce2a762fdd5ca$var$getBaseURL;
$957ce2a762fdd5ca$export$5a759dc7a1cfb72a = $957ce2a762fdd5ca$var$getOrigin;

});

var $b460729e9499f8bb$exports = {};


(parcelRequire("cw5Bf")).register((parcelRequire("cPIEy")).getBundleURL("2Lllm"), JSON.parse('["2Lllm","index.0d06dc9f.js","gYCJP","coincraft_logo_130.1b205a5d.png","7URWr","index.47b9a256.css"]'));

})();
//# sourceMappingURL=index.runtime.cf3655c2.js.map
